import { GetterTree } from 'vuex';
import { ACTIVE_STATUSES } from '@/utils/bulkJob';
import { BulkJobState, RootState } from '../types';

export const getters: GetterTree<BulkJobState, RootState> = {
	getActiveJob(state: BulkJobState): BulkJob | null {
		return state.activeJob;
	},

	getViewedJob(state: BulkJobState): BulkJob | null {
		return state.viewedJob;
	},

	getJobHistory(state: BulkJobState): BulkJob[] {
		return state.jobHistory;
	},

	getJobHistoryCount(state: BulkJobState): number {
		return state.jobHistoryCount;
	},

	getJobHistoryFilters(state: BulkJobState): TableFilterParams {
		return state.jobHistoryFilters;
	},

	hasActiveJob(state: BulkJobState): boolean {
		return !!state.activeJob && ACTIVE_STATUSES.includes(state.activeJob.status);
	}
};
